import { Card, Empty, Grid, Space } from 'antd';
import React, { useState } from 'react';
import { hooks, models } from "@vote4dance/judging-sdk";
import { _T } from '../../../../../base-react/src/Localization';
import { RoundResultHeat } from './RoundResultHeat';
var Stream = hooks.streams.Stream;
var HeatSource = models.heats.HeatSource;
import { RoundToolbar } from './RoundToolbar';
import { SolutionOutlined } from '@ant-design/icons';
const { useBreakpoint } = Grid;
export const RoundResult = (props) => {
    const { class_id, round, judging, disabled } = props;
    const [heats, loadingHeats] = Stream(HeatSource(round.round_id));
    const screens = useBreakpoint();
    const [showStatistics, setShowStatistics] = useState(false);
    const [extraFields, setExtraFields] = useState([]);
    const onClickExtraField = (value) => {
        setExtraFields((prevFields) => {
            if (prevFields.includes(value)) {
                // Remove the value if it already exists
                return prevFields.filter((field) => field !== value);
            }
            else {
                // Add the value if it doesn't exist
                return [...prevFields, value];
            }
        });
    };
    return (React.createElement(Card, { title: React.createElement(React.Fragment, null,
            React.createElement(SolutionOutlined, null),
            " ",
            _T('round.results')), extra: screens.md && React.createElement(RoundToolbar, { round: round, disabled: disabled, onClickStatistics: () => setShowStatistics(!showStatistics) }), loading: loadingHeats },
        React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
            !screens.md &&
                React.createElement(RoundToolbar, { round: round, disabled: disabled, onClickStatistics: () => setShowStatistics(!showStatistics) }),
            heats && heats.length > 0 ? heats.map((heat) => (React.createElement(RoundResultHeat, { key: heat.heat_number, class_id: class_id, round: round, heat: heat, heats: heats, judging: judging, disabled: disabled, showStatistics: showStatistics, extraFields: extraFields, onClickExtraField: onClickExtraField }))) : React.createElement(Empty, { description: false }))));
};
